var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skillModalContainer"},[_c('Presentational',{attrs:{"skillList":_vm.skillLists},on:{"update":function (skill) { return _vm.addSkill(skill); },"close":function($event){return _vm.$emit('modalClose')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }